import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addNCContent } from "../redux/actions/index";

const useNCItemList = (id, item) => {
  const dispatch = useDispatch();
  useEffect(() => {
    let order = `A`;
    if (id.match) {
      const matchOrder = id.match(/\{(.*?)\}/);
      const matchOrderColumns = id.match(/\[(.*?)\]/);
      order = (matchOrder && matchOrder[1]) ? matchOrder[1] : `A`;
      order += (matchOrderColumns && matchOrderColumns[1]) ? matchOrderColumns[1] : ``;
    }
    try {
      dispatch(addNCContent({ ref: `DI-${item.id}-TRACK`, link: null, action: `click`, scroll: true, order }));
    } catch(e) {}
  }, [item, id, dispatch])
  return null;
};

export default useNCItemList;
